import React, { useState, useEffect, useCallback } from 'react';
import './MobileVerticalScrollRail.css';

/**
 * Native up/down scrollbars are overlay-only on most phone browsers. This mimics the PC
 * scrollbar: always-visible track + thumb that tracks window scroll.
 */
export function MobileVerticalScrollRail() {
  const [thumbStyle, setThumbStyle] = useState({ height: '100%', top: '0%' });

  const update = useCallback(() => {
    const root = document.documentElement;
    const docHeight = root.scrollHeight;
    const winHeight = window.innerHeight;
    const maxScroll = Math.max(0, docHeight - winHeight);
    const y = window.scrollY || window.pageYOffset;

    if (maxScroll <= 0) {
      setThumbStyle({ height: '100%', top: '0%' });
      return;
    }

    const thumbH = Math.max(12, (winHeight / docHeight) * 100);
    const maxTop = 100 - thumbH;
    const top = (y / maxScroll) * maxTop;
    setThumbStyle({ height: `${thumbH}%`, top: `${top}%` });
  }, []);

  useEffect(() => {
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(() => update());
      ro.observe(document.documentElement);
      if (document.body) ro.observe(document.body);
    }

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      if (ro) ro.disconnect();
    };
  }, [update]);

  return (
    <div className="mobile-v-scroll-rail" aria-hidden="true">
      <div className="mobile-v-scroll-rail__thumb" style={thumbStyle} />
    </div>
  );
}
